import { apiRequest } from '../http'

// 获取用户上次选中的等级
export const fetchLastLevelSelect = () => apiRequest.get('/v1/examination/defaultLevel')

// 保存用户选中的等级
export const saveLevelSelect = (params) =>
  apiRequest.post('/v1/examination/saveDefaultLevel', params)

// 重置考试的状态 可以将完成考试的考生重置某个模块重新进行考试
export const changeStatus = (params) => apiRequest.post('/manage/examination/change_status', params)
